const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatBRL = (v) => BRL.format(Number(v) || 0);

// Números grandes da capa: R$ 2,70 mi, R$ 385 mil, R$ 8.650,00.
export const formatBRLCompacto = (v) => {
  const n = Number(v) || 0;
  const abs = Math.abs(n);
  const sinal = n < 0 ? '-' : '';
  // 999.500 arredonda para 1.000 mil: a partir daí já é milhão
  if (abs >= 999500) return `${sinal}R$ ${(abs / 1e6).toFixed(2).replace('.', ',')} mi`;
  if (abs >= 1e4) return `${sinal}R$ ${Math.round(abs / 1e3).toLocaleString('pt-BR')} mil`;
  return formatBRL(n);
};

export const formatNumero = (v) => (Number(v) || 0).toLocaleString('pt-BR');

// Data com hora (ISO do servidor) ou só o dia ('aaaa-mm-dd'), que vale como meia-noite local:
// new Date leria meia-noite UTC, o dia anterior no Brasil. Vazio ou inválido vira texto vazio.
const paraData = (v) => {
  if (!v) return null;
  const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(v) ? `${v}T00:00` : v);
  return Number.isNaN(d.getTime()) ? null : d;
};
const intl = (opcoes) => {
  const f = new Intl.DateTimeFormat('pt-BR', opcoes);
  return (v) => {
    const d = paraData(v);
    return d ? f.format(d) : '';
  };
};
export const formatData = intl({ day: '2-digit', month: '2-digit', year: 'numeric' }); // 23/09/2026
export const formatDia = intl({ day: '2-digit', month: '2-digit' }); // 23/09
export const formatHora = intl({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); // 14:05
export const formatMes = intl({ month: 'long', year: 'numeric' }); // setembro de 2026
const mesCurto = intl({ month: 'short' });
const anoCurto = intl({ year: '2-digit' });
const diaDaSemana = intl({ weekday: 'long' });
export const formatMesCurto = (v) => (paraData(v) ? `${mesCurto(v).replace('.', '')}/${anoCurto(v)}` : ''); // set/26
export const formatDiaDaSemana = (v) => (paraData(v) ? `${diaDaSemana(v)}, ${formatDia(v)}` : ''); // quarta-feira, 23/09
export const formatDataHora = (v) => (paraData(v) ? `${formatData(v)} às ${formatHora(v)}` : ''); // 23/09/2026 às 14:05
export const formatDiaHora = (v) => (paraData(v) ? `${formatDia(v)} ${formatHora(v)}` : ''); // 23/09 14:05

// O dia local (ano, mês, dia) contado em UTC: a diferença entre dois dá dias inteiros, sem horário de verão.
export const diaDoCalendario = (d) => Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());

// Distância até agora na maior unidade que cabe, arredondada: "10 segundos", "3 dias", "1 mês"
// (a régua do formatDistanceToNowStrict do date-fns, que o Financeiro usava).
const UNIDADES = [
  // [segundos da unidade, vale abaixo de (segundos), singular, plural]
  [1, 60, 'segundo', 'segundos'],
  [60, 3600, 'minuto', 'minutos'],
  [3600, 86400, 'hora', 'horas'],
  [86400, 2592000, 'dia', 'dias'],
  [2592000, 31536000, 'mês', 'meses'],
  [31536000, Infinity, 'ano', 'anos'],
];
export const formatDuracao = (v) => {
  const d = paraData(v);
  if (!d) return '';
  const segundos = Math.abs(Date.now() - d.getTime()) / 1000;
  const [tamanho, , um, varios] = UNIDADES.find(([, ate]) => segundos < ate);
  const n = Math.round(segundos / tamanho);
  if (um === 'mês' && n === 12) return '1 ano';
  return `${n} ${n === 1 ? um : varios}`;
};
export const formatRelativo = (v) => (paraData(v) ? `há ${formatDuracao(v)}` : ''); // há 3 dias
